<div class="add-connection-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="title-group">
      <h1 class="dialog-title">{{ dialogTitle }}</h1>
    </div>
    <button
      mat-icon-button
      class="close-button"
      (click)="onAttemptClose()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <mat-dialog-content class="dialog-content">
    <!-- Only shown when the selected type/auth mode references a pre-created
         secret (SCRUM-623) — e.g. registry Box connections never do. -->
    @if (showSecretsBanner) {
      <div class="info-banner">
        <div class="info-content">
          <mat-icon class="info-icon">info</mat-icon>
          <div class="info-text">
            Before Connection creation the Secrets must be created in Secret
            Manager beforehand
          </div>
        </div>
        <button
          mat-stroked-button
          class="info-action"
          (click)="onOpenSettings()"
        >
          To Settings
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    }

    <form [formGroup]="connectionBasicsForm" class="basics-form">
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Name</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Name"
            autocomplete="off"
            spellcheck="false"
          />
          @if (getFormFieldError(connectionBasicsForm, "name")) {
            <mat-error>
              {{ getFormFieldError(connectionBasicsForm, "name") }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Type</mat-label>
          <mat-select
            formControlName="type"
            (selectionChange)="onTypeChange($event.value)"
          >
            <mat-option value="database">
              <span class="connection-type-option">
                <mat-icon
                  class="connection-type-icon"
                  svgIcon="connection-database"
                ></mat-icon>
                <span>Database</span>
              </span>
            </mat-option>
            <mat-option value="datafusion">
              <span class="connection-type-option">
                <mat-icon
                  class="connection-type-icon"
                  svgIcon="connection-datafusion"
                ></mat-icon>
                <span>DataFusion</span>
              </span>
            </mat-option>
            <mat-option value="llm">
              <span class="connection-type-option">
                <mat-icon
                  class="connection-type-icon"
                  svgIcon="connection-cloud"
                ></mat-icon>
                <span>LLM</span>
              </span>
            </mat-option>
            <mat-option value="box">
              <span class="connection-type-option">
                <mat-icon
                  class="connection-type-icon"
                  svgIcon="connection-box"
                ></mat-icon>
                <span>Box</span>
              </span>
            </mat-option>
            <mat-option value="objectstorage">
              <span class="connection-type-option">
                <mat-icon
                  class="connection-type-icon"
                  svgIcon="connection-object-storage"
                ></mat-icon>
                <span>Object Storage</span>
              </span>
            </mat-option>
            <mat-option value="service">
              <span class="connection-type-option">
                <mat-icon
                  class="connection-type-icon"
                  fontIcon="miscellaneous_services"
                ></mat-icon>
                <span>Service</span>
              </span>
            </mat-option>
          </mat-select>
          @if (getFormFieldError(connectionBasicsForm, "type")) {
            <mat-error>
              {{ getFormFieldError(connectionBasicsForm, "type") }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description (optional)</mat-label>
        <textarea
          matInput
          formControlName="description"
          placeholder="Enter short description…"
          rows="3"
        ></textarea>
      </mat-form-field>
    </form>

    @if (selectedTabIndex() !== null) {
      <div class="details-section">
        @if (selectedTabIndex() === 0) {
          <div class="tab-content">
            <form [formGroup]="databaseForm" class="connection-form">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Database Type</mat-label>
                <mat-select formControlName="databaseType">
                  @for (dbType of databaseTypes; track $index) {
                    <mat-option [value]="dbType">{{
                      dbType === "SQLServer" ? "SQL Server" : dbType
                    }}</mat-option>
                  }
                </mat-select>
                @if (getFormFieldError(databaseForm, "databaseType")) {
                  <mat-error>
                    {{ getFormFieldError(databaseForm, "databaseType") }}
                  </mat-error>
                }
              </mat-form-field>
              <div class="form-row">
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Host</mat-label>
                  <input
                    matInput
                    formControlName="host"
                    placeholder="localhost"
                    autocomplete="off"
                    spellcheck="false"
                  />
                  @if (getFormFieldError(databaseForm, "host")) {
                    <mat-error>
                      {{ getFormFieldError(databaseForm, "host") }}
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline" class="port-field">
                  <mat-label>Port</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="port"
                    placeholder="5432"
                    autocomplete="off"
                  />
                  @if (getFormFieldError(databaseForm, "port")) {
                    <mat-error>
                      {{ getFormFieldError(databaseForm, "port") }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Username</mat-label>
                  <input
                    matInput
                    formControlName="username"
                    placeholder="postgres"
                    autocomplete="username"
                    spellcheck="false"
                  />
                  @if (getFormFieldError(databaseForm, "username")) {
                    <mat-error>
                      {{ getFormFieldError(databaseForm, "username") }}
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Database</mat-label>
                  <input
                    matInput
                    formControlName="dbname"
                    placeholder="mydb"
                    autocomplete="off"
                    spellcheck="false"
                  />
                  @if (getFormFieldError(databaseForm, "dbname")) {
                    <mat-error>
                      {{ getFormFieldError(databaseForm, "dbname") }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <app-secret-picker
                [control]="$any(databaseForm.get('passwordSecretId'))"
                [secrets]="store.secrets()"
                label="Secret"
                fieldClass="full-width"
                [error]="getFormFieldError(databaseForm, 'passwordSecretId')"
                (goToSettings)="onOpenSettings()"
              />
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Connection Options (Optional)</mat-label>
                <textarea
                  matInput
                  formControlName="options"
                  placeholder='{"ssl": true, "sslmode": "require"}'
                  rows="3"
                ></textarea>
              </mat-form-field>
            </form>
          </div>
        }
        @if (selectedTabIndex() === 1) {
          <div class="tab-content">
            <form [formGroup]="dataFusionForm" class="connection-form">
              <p class="form-hint">
                Queries run on this deployment's DataFusion engine; there is no
                address to configure.
              </p>
              <p class="form-hint">
                Storage credentials (bucket, region, access key) are managed via
                a linked Object Storage connection.
              </p>
            </form>
          </div>
        }
        @if (selectedTabIndex() === 2) {
          <div class="tab-content">
            <form [formGroup]="llmForm" class="connection-form">
              <div class="form-row">
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>LLM Type</mat-label>
                  <mat-select formControlName="llmType">
                    @for (type of llmTypes; track $index) {
                      <mat-option [value]="type">{{ type }}</mat-option>
                    }
                  </mat-select>
                  @if (getFormFieldError(llmForm, "llmType")) {
                    <mat-error>{{
                      getFormFieldError(llmForm, "llmType")
                    }}</mat-error>
                  }
                </mat-form-field>
                <app-secret-picker
                  [control]="$any(llmForm.get('apiKeySecretId'))"
                  [secrets]="store.secrets()"
                  label="API Key Secret"
                  fieldClass="flex-1"
                  [error]="getFormFieldError(llmForm, 'apiKeySecretId')"
                  (goToSettings)="onOpenSettings()"
                />
              </div>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Endpoint (optional)</mat-label>
                <input
                  matInput
                  type="url"
                  formControlName="endpoint"
                  placeholder="https://api.openai.com/v1"
                  autocomplete="off"
                  spellcheck="false"
                />
              </mat-form-field>
            </form>
          </div>
        }
        @if (selectedTabIndex() === 3) {
          <div class="tab-content">
            <form [formGroup]="boxForm" class="connection-form">
              @if (isLegacyBoxConnection()) {
                <div class="info-banner">
                  <div class="info-content">
                    <mat-icon class="info-icon">info</mat-icon>
                    <div class="info-text">
                      This connection uses deprecated inline credentials. Select
                      a Box app below to migrate it to the managed registry.
                    </div>
                  </div>
                </div>
              }
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Box App</mat-label>
                <mat-select formControlName="boxAppId">
                  @for (app of boxApps(); track app.boxAppId) {
                    <mat-option [value]="app.boxAppId">
                      {{ app.name }}
                      @if (app.description) {
                        — {{ app.description }}
                      }
                    </mat-option>
                  }
                </mat-select>
                @if (boxApps().length === 0) {
                  <mat-hint
                    >No Box apps are registered. An administrator must register
                    one first.</mat-hint
                  >
                }
                @if (getFormFieldError(boxForm, "boxAppId")) {
                  <mat-error>{{
                    getFormFieldError(boxForm, "boxAppId")
                  }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Root Folder ID</mat-label>
                <input
                  matInput
                  formControlName="rootFolderId"
                  autocomplete="off"
                  spellcheck="false"
                  placeholder="0 for enterprise-wide"
                />
                <mat-hint
                  >The folder subtree this connection is limited to. Use "0" for
                  enterprise-wide access.</mat-hint
                >
                @if (getFormFieldError(boxForm, "rootFolderId")) {
                  <mat-error>{{
                    getFormFieldError(boxForm, "rootFolderId")
                  }}</mat-error>
                }
              </mat-form-field>
              <div class="form-section">
                <p class="form-label">
                  Allowed Operations
                  <span class="form-hint-inline"
                    >(leave empty to allow all)</span
                  >
                </p>
                <mat-chip-listbox
                  formControlName="allowedOperations"
                  [multiple]="true"
                  aria-label="Allowed operations"
                >
                  @for (op of boxOperations; track op) {
                    <mat-chip-option [value]="op">{{ op }}</mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
            </form>
          </div>
        }
        @if (selectedTabIndex() === 4) {
          <div class="tab-content">
            <form [formGroup]="objectStorageForm" class="connection-form">
              <div class="form-row">
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Provider</mat-label>
                  <mat-select formControlName="provider">
                    @for (provider of objectStorageProviders; track $index) {
                      <mat-option [value]="provider">
                        <span class="provider-option">
                          <mat-icon
                            class="provider-icon"
                            [svgIcon]="getProviderIcon(provider)"
                          ></mat-icon>
                          <span>{{ getProviderLabel(provider) }}</span>
                        </span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Auth Type</mat-label>
                  <mat-select formControlName="authType">
                    @for (
                      authType of getProviderAuthTypes(
                        objectStorageForm.get("provider")?.value
                      );
                      track authType
                    ) {
                      <mat-option [value]="authType">
                        {{ getAuthTypeLabel(authType) }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (isLoadingOAuthProviders()) {
                    <mat-hint>
                      <mat-spinner
                        diameter="12"
                        class="inline-spinner"
                      ></mat-spinner>
                      Checking OAuth availability...
                    </mat-hint>
                  }
                </mat-form-field>
              </div>
              <!-- Keyless (EHQ-427): the bucket comes from an approved storage grant -->
              @if (isKeylessSelected) {
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Storage grant</mat-label>
                  <mat-select formControlName="storageGrantId">
                    @for (
                      grant of store.approvedStorageGrants();
                      track grant.storageGrantId
                    ) {
                      <mat-option [value]="grant.storageGrantId">
                        {{ grantLabel(grant) }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (store.isLoadingStorageGrants()) {
                    <mat-hint>Loading storage grants...</mat-hint>
                  } @else if (store.approvedStorageGrants().length === 0) {
                    <mat-hint
                      >No approved storage access yet. Request it under Project
                      Settings &gt; Connections.</mat-hint
                    >
                  } @else {
                    <mat-hint
                      >Uses Enlighten's service account; no key is stored.</mat-hint
                    >
                  }
                  @if (getFormFieldError(objectStorageForm, "storageGrantId")) {
                    <!-- The error replaces the hint, so with no grants it repeats where to request one. -->
                    @if (store.approvedStorageGrants().length === 0) {
                      <mat-error
                        >No approved storage access yet. Request it under Project
                        Settings &gt; Connections.</mat-error
                      >
                    } @else {
                      <mat-error>Pick a storage grant.</mat-error>
                    }
                  }
                </mat-form-field>
              }
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Bucket</mat-label>
                <input
                  matInput
                  formControlName="bucket"
                  autocomplete="off"
                  spellcheck="false"
                  [readonly]="isKeylessSelected"
                />
                @if (isKeylessSelected) {
                  <mat-hint>Set by the storage grant.</mat-hint>
                }
                @if (getFormFieldError(objectStorageForm, "bucket")) {
                  <mat-error>{{
                    getFormFieldError(objectStorageForm, "bucket")
                  }}</mat-error>
                }
              </mat-form-field>
              @if (
                isObjectStorageFieldVisible("endpoint") ||
                isObjectStorageFieldVisible("region")
              ) {
                <div class="form-row">
                  @if (isObjectStorageFieldVisible("endpoint")) {
                    <mat-form-field appearance="outline" class="flex-1">
                      <mat-label>Endpoint</mat-label>
                      <input
                        matInput
                        type="url"
                        formControlName="endpoint"
                        autocomplete="off"
                        spellcheck="false"
                      />
                      @if (getFormFieldError(objectStorageForm, "endpoint")) {
                        <mat-error>{{
                          getFormFieldError(objectStorageForm, "endpoint")
                        }}</mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (isObjectStorageFieldVisible("region")) {
                    <mat-form-field appearance="outline" class="flex-1">
                      <mat-label>Region</mat-label>
                      <input
                        matInput
                        formControlName="region"
                        autocomplete="off"
                        spellcheck="false"
                      />
                      @if (getFormFieldError(objectStorageForm, "region")) {
                        <mat-error>{{
                          getFormFieldError(objectStorageForm, "region")
                        }}</mat-error>
                      }
                    </mat-form-field>
                  }
                </div>
              }
              @if (isObjectStorageFieldVisible("projectId")) {
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Project ID (optional)</mat-label>
                    <input
                      matInput
                      formControlName="projectId"
                      autocomplete="off"
                      spellcheck="false"
                    />
                    @if (getFormFieldError(objectStorageForm, "projectId")) {
                      <mat-error>{{
                        getFormFieldError(objectStorageForm, "projectId")
                      }}</mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              @if (isObjectStorageFieldVisible("accountName")) {
                <div class="form-row">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Account Name</mat-label>
                    <input
                      matInput
                      formControlName="accountName"
                      autocomplete="off"
                      spellcheck="false"
                    />
                    @if (getFormFieldError(objectStorageForm, "accountName")) {
                      <mat-error>{{
                        getFormFieldError(objectStorageForm, "accountName")
                      }}</mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              @if (isKeylessSelected) {
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Prefix</mat-label>
                  <input
                    matInput
                    formControlName="prefix"
                    autocomplete="off"
                    spellcheck="false"
                  />
                  <mat-hint>The grant's prefix, or a folder under it.</mat-hint>
                  @if (keylessPrefixProblem) {
                    <mat-error>{{ keylessPrefixProblem }}</mat-error>
                  }
                </mat-form-field>
              }
              <!-- AccessKey / ServiceAccount credentials -->
              @if (!isOAuthSelected && !isKeylessSelected) {
                <div class="form-row">
                  <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Access Key</mat-label>
                    <input
                      matInput
                      formControlName="accessKey"
                      autocomplete="off"
                      spellcheck="false"
                    />
                    @if (getFormFieldError(objectStorageForm, "accessKey")) {
                      <mat-error>{{
                        getFormFieldError(objectStorageForm, "accessKey")
                      }}</mat-error>
                    }
                  </mat-form-field>
                  <app-secret-picker
                    [control]="$any(objectStorageForm.get('secretId'))"
                    [secrets]="store.secrets()"
                    label="Secret"
                    fieldClass="flex-1"
                    [error]="getFormFieldError(objectStorageForm, 'secretId')"
                    (goToSettings)="onOpenSettings()"
                  />
                </div>
              }
              <!-- OAuth credentials section -->
              @if (isOAuthSelected) {
                <div class="oauth-section">
                  <div class="oauth-credential-row">
                    <mat-form-field appearance="outline" class="flex-1">
                      <mat-label>OAuth Credential</mat-label>
                      <mat-select formControlName="userCredentialId">
                        @if (!isLoadingOAuthCredentials()) {
                          <mat-option value="">Select a credential</mat-option>
                          @for (
                            credential of oauthCredentials();
                            track credential
                          ) {
                            <mat-option
                              [value]="credential.userStorageCredentialId"
                              [disabled]="isCredentialExpired(credential)"
                              [matTooltip]="
                                isCredentialExpired(credential)
                                  ? 'This credential has expired. Authorize a new one.'
                                  : ''
                              "
                            >
                              <span
                                class="credential-option"
                                [class.credential-expired]="
                                  isCredentialExpired(credential)
                                "
                              >
                                @if (isCredentialExpired(credential)) {
                                  <mat-icon class="credential-expired-icon"
                                    >warning</mat-icon
                                  >
                                }
                                {{ getCredentialLabel(credential) }}
                              </span>
                            </mat-option>
                          }
                          @if (oauthCredentials().length === 0) {
                            <mat-option disabled value="">
                              No credentials yet — authorize below
                            </mat-option>
                          }
                        }
                        @if (isLoadingOAuthCredentials()) {
                          <mat-option disabled value="">
                            <mat-spinner
                              diameter="16"
                              class="inline-spinner"
                            ></mat-spinner>
                            Loading credentials…
                          </mat-option>
                        }
                      </mat-select>
                      @if (
                        getFormFieldError(objectStorageForm, "userCredentialId")
                      ) {
                        <mat-error>
                          {{
                            getFormFieldError(
                              objectStorageForm,
                              "userCredentialId"
                            )
                          }}
                        </mat-error>
                      }
                    </mat-form-field>
                    <button
                      mat-stroked-button
                      type="button"
                      class="authorize-button"
                      [disabled]="
                        isInitiatingOAuth() || !selectedOAuthProviderConfigId()
                      "
                      (click)="
                        selectedOAuthProviderConfigId() &&
                          onAuthorizeNew(selectedOAuthProviderConfigId()!)
                      "
                      matTooltip="Open a browser window to authorize access"
                    >
                      @if (isInitiatingOAuth()) {
                        <mat-spinner
                          diameter="16"
                          class="spinner"
                        ></mat-spinner>
                      }
                      @if (!isInitiatingOAuth()) {
                        <mat-icon>open_in_new</mat-icon>
                      }
                      {{ isInitiatingOAuth() ? "Opening…" : "Authorize New" }}
                    </button>
                  </div>
                  <!-- Multiple provider configs: let user pick which one to authorize with -->
                  @if (oauthProviders().length > 1) {
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>OAuth Provider Configuration</mat-label>
                      <mat-select
                        [ngModel]="selectedOAuthProviderConfigId()"
                        (ngModelChange)="
                          selectedOAuthProviderConfigId.set($event)
                        "
                        [ngModelOptions]="{ standalone: true }"
                      >
                        @for (
                          p of oauthProviders();
                          track p.oauthProviderConfigId
                        ) {
                          <mat-option [value]="p.oauthProviderConfigId">
                            {{ p.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-hint
                        >Select which provider configuration to use when
                        authorizing</mat-hint
                      >
                    </mat-form-field>
                  }
                </div>
              }
            </form>
          </div>
        }
        @if (selectedTabIndex() === 5) {
          <div class="tab-content">
            <form [formGroup]="serviceForm" class="connection-form">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Service Mode</mat-label>
                <mat-select formControlName="mode">
                  <mat-option
                    value="global"
                    [disabled]="globalServices().length === 0"
                  >
                    Global Service (platform-managed)
                    @if (globalServices().length === 0) {
                      — none available
                    }
                  </mat-option>
                  <mat-option value="custom"
                    >Custom Service (external URL)</mat-option
                  >
                </mat-select>
              </mat-form-field>

              @if (serviceForm.get("mode")?.value === "global") {
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Global Service</mat-label>
                  <mat-select formControlName="globalServiceId">
                    @for (gs of globalServices(); track gs.serviceId) {
                      <mat-option [value]="gs.serviceId">
                        {{ gs.name }}
                        @if (gs.description) {
                          — {{ gs.description }}
                        }
                      </mat-option>
                    }
                  </mat-select>
                  @if (getFormFieldError(serviceForm, "globalServiceId")) {
                    <mat-error>{{
                      getFormFieldError(serviceForm, "globalServiceId")
                    }}</mat-error>
                  }
                </mat-form-field>
              }

              @if (serviceForm.get("mode")?.value === "custom") {
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Service URL</mat-label>
                  <input
                    matInput
                    formControlName="url"
                    placeholder="https://api.example.com"
                  />
                  @if (getFormFieldError(serviceForm, "url")) {
                    <mat-error>{{
                      getFormFieldError(serviceForm, "url")
                    }}</mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Authentication</mat-label>
                  <mat-select formControlName="authType">
                    <mat-option value="none">None</mat-option>
                    <mat-option value="bearer">Bearer Token</mat-option>
                    <mat-option value="customHeader">Custom Header</mat-option>
                    <mat-option value="queryParam">Query Parameter</mat-option>
                  </mat-select>
                </mat-form-field>

                @if (serviceForm.get("authType")?.value !== "none") {
                  <app-secret-picker
                    [control]="$any(serviceForm.get('authSecretId'))"
                    [secrets]="store.secrets()"
                    label="Auth Secret"
                    fieldClass="full-width"
                    [error]="getFormFieldError(serviceForm, 'authSecretId')"
                    (goToSettings)="onOpenSettings()"
                  />
                }

                @if (serviceForm.get("authType")?.value === "customHeader") {
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Header Name</mat-label>
                    <input
                      matInput
                      formControlName="authHeaderName"
                      placeholder="X-API-Key"
                    />
                    @if (getFormFieldError(serviceForm, "authHeaderName")) {
                      <mat-error>{{
                        getFormFieldError(serviceForm, "authHeaderName")
                      }}</mat-error>
                    }
                  </mat-form-field>
                }

                @if (serviceForm.get("authType")?.value === "queryParam") {
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Parameter Name</mat-label>
                    <input
                      matInput
                      formControlName="authParamName"
                      placeholder="api_key"
                    />
                    @if (getFormFieldError(serviceForm, "authParamName")) {
                      <mat-error>{{
                        getFormFieldError(serviceForm, "authParamName")
                      }}</mat-error>
                    }
                  </mat-form-field>
                }
              }

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Timeout (ms, optional)</mat-label>
                <input
                  matInput
                  formControlName="timeoutMs"
                  placeholder="30000"
                  type="number"
                />
                <mat-hint>Override the default request timeout</mat-hint>
              </mat-form-field>
            </form>
          </div>
        }
      </div>
    }

    @if (error()) {
      <div class="error">
        {{ error() }}
      </div>
    }

    @if (testResult()?.success) {
      <div class="test-result test-result--success">
        <mat-icon class="test-result-icon">check_circle</mat-icon>
        <span>{{ testResult()!.message }}</span>
      </div>
    }
    @if (testResult() && !testResult()!.success) {
      <div class="test-result test-result--error">
        <mat-icon class="test-result-icon">error</mat-icon>
        <span>{{ testResult()!.message }}</span>
      </div>
    }
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <div class="dialog-actions">
    <button mat-button class="cancel-button" (click)="onAttemptClose()">
      Cancel
    </button>
    <div class="actions-right">
      <button
        mat-stroked-button
        class="test-button"
        [disabled]="!canTest"
        (click)="onTestConnection()"
      >
        @if (isTesting()) {
          <mat-spinner diameter="16" class="spinner"></mat-spinner>
        }
        {{ isTesting() ? "Testing…" : "Test" }}
      </button>
      <button
        mat-raised-button
        class="create-button"
        [disabled]="!canSave || isSaving()"
        (click)="onSaveConnection()"
      >
        @if (!isSaving()) {
          <span>{{ saveButtonLabel }}</span>
        }
        @if (isSaving()) {
          <span>
            <mat-spinner diameter="16" class="spinner"></mat-spinner>
            {{ savingButtonLabel }}
          </span>
        }
      </button>
    </div>
  </div>
</div>
